module.exports = __webpack_public_path__ + "media/theme/border-10-6167206e.png";